import React, { useEffect, useState } from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Lead, CAMPAIGN_DRIP_SCHEDULES } from '../../data/mockLeads';
import { Megaphone, Check } from 'lucide-react';
import { cn } from '../../lib/utils';
interface EnrollCampaignModalProps {
  lead: Lead | null;
  open: boolean;
  onClose: () => void;
  onConfirm: (leadId: string, campaignName: string) => void;
}
export function EnrollCampaignModal({
  lead,
  open,
  onClose,
  onConfirm
}: EnrollCampaignModalProps) {
  const campaigns = Object.keys(CAMPAIGN_DRIP_SCHEDULES);
  const expected = lead?.campaignEnrollment.expectedCampaign;
  const [selected, setSelected] = useState<string>('');
  useEffect(() => {
    if (open && lead) {
      setSelected(expected && campaigns.includes(expected) ? expected : '');
    }
  }, [open, lead?.id]);
  if (!lead) return null;
  return <Modal open={open} onClose={onClose} title="Enroll in Campaign" subtitle={<div className="flex flex-wrap items-center gap-2 text-xs" data-id="element-70">
          <span data-id="element-71">{lead.name}</span>
          <span className="text-slate-300" data-id="element-72">•</span>
          <span data-id="element-73">{lead.loanPurpose}</span>
          <span className="text-slate-300" data-id="element-74">•</span>
          <span data-id="element-75">{lead.propertyState}</span>
        </div>} data-id="element-69">
      <div className="space-y-4" data-id="element-76">
        {expected && <div className="flex items-start gap-2 p-3 rounded-lg bg-rose-50 border border-rose-200/60" data-id="element-77">
            <span className="text-xs text-rose-700" data-id="element-78">
              <span className="font-semibold" data-id="element-79">Expected campaign:</span>{' '}
              {expected}
            </span>
          </div>}

        <div data-id="element-80">
          <label className="block text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2" data-id="element-81">
            Select Campaign
          </label>
          <div className="space-y-2" data-id="element-82">
            {campaigns.map(c => {
            const isActive = selected === c;
            const stepCount = CAMPAIGN_DRIP_SCHEDULES[c].length;
            return <button key={c} type="button" onClick={() => setSelected(c)} className={cn('w-full flex items-center justify-between gap-3 px-3 py-2.5 rounded-lg border text-left transition-colors', isActive ? 'border-indigo-500 bg-indigo-50/60 ring-1 ring-indigo-200' : 'border-slate-200 hover:border-slate-300 hover:bg-slate-50')} data-id="element-83">
                  <div className="flex items-center gap-2 min-w-0" data-id="element-84">
                    <span className={cn('inline-flex h-4 w-4 items-center justify-center rounded-full border', isActive ? 'bg-indigo-600 border-indigo-600 text-white' : 'bg-white border-slate-300')} aria-hidden="true" data-id="element-85">
                      {isActive && <Check className="w-3 h-3" strokeWidth={3} data-id="element-86" />}
                    </span>
                    <span className="text-sm font-medium text-slate-900 truncate" data-id="element-87">
                      {c}
                    </span>
                    {c === expected && <Badge variant="alert" data-id="element-88">Expected</Badge>}
                  </div>
                  <span className="text-xs text-slate-500 shrink-0" data-id="element-89">
                    {stepCount} drip steps
                  </span>
                </button>;
          })}
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 pt-2 border-t border-slate-200" data-id="element-90">
          <Button variant="ghost" onClick={onClose} data-id="element-91">
            Cancel
          </Button>
          <Button variant="primary" disabled={!selected} onClick={() => {
          if (selected) {
            onConfirm(lead.id, selected);
            onClose();
          }
        }} data-id="element-92">
            <Megaphone className="w-4 h-4 mr-1.5" data-id="element-93" />
            Enroll
          </Button>
        </div>
      </div>
    </Modal>;
}